import { ItemCompleteProps } from "app/shared/components/modal/auto-complete/auto-complete";
import i18n from "app/shared/language/i18n";

interface ProviderTopUp {
  ID: string;
  NAME: string;
  Other: string;
}

interface ServiceTopUp {
  ID: string;
  NAME: string;
  NAME_DESC: {
    name_vi: string;
    name_en: string;
  };
  PROVIDER: ProviderTopUp[];
  CODE: string;
  URL: string;
  priority: number;
}

interface PrincesTopUp {
  ID: string;
  NAME: string;
  Other: string;
}

interface TopUpDataJson {
  SERVICE: ServiceTopUp[];
  DENOMINATIONS: PrincesTopUp[];
}

let toUpSerViceJson: TopUpDataJson;

export function loadTopUpServiceJson() {
  return new Promise(async (resolve) => {
    if (!toUpSerViceJson) toUpSerViceJson = await import("../../../shared/util/data-json/top-up.json");
    resolve(0);
  });
}

export const handlerTopUpServices = () => {
  const list: ItemCompleteProps[] = [];
  const dataJson: TopUpDataJson = toUpSerViceJson;
  if (dataJson.SERVICE.length) {
    const serviceJson: ServiceTopUp[] = toUpSerViceJson.SERVICE;
    if (serviceJson)
      serviceJson.forEach((_item) => {
        let name = i18n.language === "en" ? _item.NAME_DESC.name_en : _item.NAME_DESC.name_vi;
        list.push({ value: _item.ID || "", label: name, icon: _item.URL });
      });
  }

  return list;
};

export const handlerTopUpPrinces = () => {
  const list: ItemCompleteProps[] = [];
  const dataJson: TopUpDataJson = toUpSerViceJson;
  if (dataJson.DENOMINATIONS.length) {
    const princesJson: PrincesTopUp[] = toUpSerViceJson.DENOMINATIONS;
    princesJson.forEach((_item) => {
      list.push({ value: _item.ID || "", label: _item.NAME || "", other: _item.Other });
    });
  }
  return list;
};

export const handlerTopUpProviders = (service?: string) => {
  const list: ItemCompleteProps[] = [];
  const dataJson: TopUpDataJson = toUpSerViceJson;
  if (dataJson.SERVICE.length) {
    const serviceJson: ServiceTopUp[] = toUpSerViceJson.SERVICE;
    serviceJson.filter((_item) => {
      if (_item.ID === service) {
        _item.PROVIDER.forEach((_provider) => {
          list.push({ value: _provider.ID || "", label: _provider.NAME });
        });
      }
    });
  }
  return list;
};

export const getTopUpService = (value?: string) => {
  const serviceJson: ServiceTopUp[] = toUpSerViceJson.SERVICE;
  const filterList = serviceJson.filter((_item) => {
    return _item.ID === value;
  });
  if (filterList.length) return filterList[0];
  return;
};

export const getTopUpProvider = (service?: string, provider?: string) => {
  let providerList: ProviderTopUp[] = [];
  const serviceJson: ServiceTopUp[] = toUpSerViceJson.SERVICE;
  const serviceFilter = serviceJson.filter((_item) => {
    return _item.ID === service;
  });
  if (serviceFilter.length) {
    providerList = serviceFilter[0].PROVIDER.filter((_provider) => {
      return _provider.ID === provider;
    });
    if (providerList.length) return providerList[0];
  }
  return;
};
